import { Injectable, Component, Type } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { EN_MONTHS, ML_MONTHS, TITHI, NAKSATRAS, WEEKDAYS } from '../../app.constants';
import { AppModalService } from '@otas/shared/ui/app-modal/app-modal.service';

/** Loosely-typed view over AppModalRef with the legacy NgbModalRef result
 *  typing (Promise<any>) so existing call sites compile unchanged. */
export interface ContinuosModalRef {
  componentInstance: any;
  result: Promise<any>;
  close(value?: unknown): void;
  dismiss(reason?: unknown): void;
}
import { IContinousFilterModel } from './continous-filter-model';
import * as _ from 'underscore';
import moment from 'moment';
import { PanEventJson } from '@otas/model/panchang/panchangam-json';
import { DateService } from 'app/services/date.service';
import { TranslatePipe } from '@otas/translate/translate.pipe';
import { TranslateService } from '@otas/translate/translate.service';

@Injectable({
  providedIn: 'root'
})
export class ContinuosBookingModalService {
  private subject = new Subject<any>;


  _translatorPipe: TranslatePipe;

  constructor(private appModal: AppModalService, private http: HttpClient, private ts: TranslateService) {

  }
  myMethod(data) {
    this.subject.next({ list: data });
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  openModalForContinuosBooking(component: Component, options?: {
    star?: string;
    customProperty?: string;
    dates?: number[];
    quantity?: number;
    startDate?: Date;
    keyboard?: 'english' | 'malayalam' | 'manglish';
  }
  ): ContinuosModalRef {
    // AppModal (centered CDK overlay) replaces the legacy NgbModal open — the
    // old per-caller `container` anchor ('app-pooja-booking-stoda' vs 'body')
    // is obsolete, every open is a body-level centered card. The AppModal
    // NgbActiveModal bridge keeps the modal component's close()/dismiss()
    // contract unchanged; the component brings its own header, so the card is
    // chrome-less. keyboard:false mirrors the legacy options (no Esc close).
    const modalRef = this.appModal.open(component as unknown as Type<unknown>, {
      size: 'lg', showClose: false, keyboard: false, modalClass: 'cbm-modal',
    }) as unknown as ContinuosModalRef;
    const instance: any = modalRef.componentInstance;

    // ---------- MODE 1: continuous booking ----------
    if (options?.startDate) {
      instance.fromDate = options.startDate;
      instance.toDate = moment(options.startDate)
        .add(1, 'year')
        .toDate();
    }

    if (options?.keyboard) {
      instance.keyboard = options.keyboard;
    }

    // ---------- MODE 2: normal booking ----------
    if (options?.star) {
      instance.star = options.star;
    }

    if (options?.dates) {
      instance.datesTobeRemoved = options.dates;
    }

    if (options?.quantity) {
      instance.countSubject.next(options.quantity);
    }

    // ---------- common customProperty handling ----------
    if (options?.customProperty) {
      const isMalayalam =
        (sessionStorage.getItem('language') ||
          localStorage.getItem('language')) === 'malayalam';

      const customProperty = options.customProperty.split('(');

      if (customProperty[0] === 'STAR') {
        const star = customProperty[1].replace(')', '').split('%')[0];
        instance.star =
          NAKSATRAS.find(e => e.en === star || e.ml === star)?.[
          isMalayalam ? 'ml' : 'en'
          ];
      } else if (customProperty[0] === 'THIDHI') {
        const thidhi = customProperty[1].replace(')', '').split('%')[0];
        instance.thidhi =
          TITHI.find(e => e.en === thidhi || e.ml === thidhi)?.[
          isMalayalam ? 'ml' : 'en'
          ];
      } else if (customProperty[0] === 'WEEK') {
        const week = customProperty[1].replace(')', '').split('%')[0];
        instance.week =
          WEEKDAYS.find(e => e.en === week || e.ml === week)?.[
          isMalayalam ? 'ml' : 'en'
          ];
      } else if (customProperty[0] === 'MAL/ENG') {
        const filterValues = customProperty[1].replace(')', '').split('^');
        const value = ['-1', '-2'].includes(filterValues[0]) ? -1 : filterValues[0];

        if (filterValues[1].includes('ml')) {
          const selectedMonth = ML_MONTHS.find(
            e => e.en === value || e.ml === value
          );
          instance.varsham =
            (isMalayalam ? selectedMonth?.ml : selectedMonth?.en) || value;
        } else {
          instance.enMonth = +value;
        }
      }

      const limit = +options.customProperty.split('%')[1];
      if (!isNaN(limit)) {
        instance.countSubject.next(limit);
      }
    }

    return modalRef;
  }

  handleDateToChange(from, to, id): Observable<any> {
    return this.http.get<any>(`panchangam/${from}/${to}/${id}`);
  }

  panchangFilter(selectedFilters, panEventsFor50yr: PanEventJson[], inputValue, fromDate) {
    const from: any = (moment(fromDate).set({ hour: 0, minute: 0, second: 0 }).toDate() as any) * 1;
    let index = _.findIndex(panEventsFor50yr, e => DateService.isSame(from, ((moment(e.date).toDate() as any) * 1) as any));
    if (index === -1) {
      index = this.nextValidDate(panEventsFor50yr, from);
    }

    const panEvents = panEventsFor50yr.slice(index, panEventsFor50yr.length);
    const varsham = selectedFilters.varsham;
    const enMonth = selectedFilters.enMonth;
    const week = selectedFilters.week;
    const thidhi = selectedFilters.thidhi;
    const star = selectedFilters.star;
    const monthOption = selectedFilters.monthOption;
    const weekOption: { id: number, name: string, type: string, week: string } = selectedFilters.weekOption;
    const lang = sessionStorage.getItem('language') === 'malayalam';
    let displaypanEvents = _.map(panEvents);
    displaypanEvents.forEach(element => {
      element.selected = true;
    });
    if (!!enMonth && +enMonth >= 0) {
      displaypanEvents = _.filter(panEvents, element => moment(element.date).toDate().getMonth() === +enMonth - 1)

    } else if (+enMonth === -1) {
      displaypanEvents = _.filter(panEvents, element => moment(element.date).toDate().getDate() === 1);

    }
    else {
      displaypanEvents = _.map(panEvents);
    }
    if (monthOption) {
      displaypanEvents = _.filter(displaypanEvents, e => new Date(e.date).getDate() === +monthOption);

    }

    if (week) {
      const weekKey = lang ? 'week' : 'enWeek';
      displaypanEvents = _.filter(displaypanEvents, ele => ele[weekKey].includes(week));

    }
    if (varsham) {
      const yearKey = lang ? 'year' : ('enYear');
      if (+varsham === -1) {
        displaypanEvents = _.filter(displaypanEvents, ele => (ele[yearKey].slice(-2)).includes(varsham));
      } else {
        displaypanEvents = _.filter(displaypanEvents, ele => ele[yearKey].includes(varsham));
      }
    }
    if (thidhi) {
      const thithiKey = lang ? 'thithi' : ('enThithi');
      displaypanEvents = _.filter(displaypanEvents, ele => ele[thithiKey].includes(thidhi));
    }
    if (star) {
      const nakshathraKey = lang ? 'nakshathra' : ('enNakshathra');
      displaypanEvents = _.filter(displaypanEvents, ele => ele[nakshathraKey].includes(star));

    }
    if (weekOption) {
      displaypanEvents = this.hasWeekOption(weekOption, displaypanEvents);

    }
    if (!displaypanEvents.length) {
      displaypanEvents = [];
      displaypanEvents = _.map(panEvents);

    }

    const displaypanEventDates: Date[] = _.map(_.map(displaypanEvents), e => moment(e.date).toDate());

    const toDate = displaypanEventDates && displaypanEventDates.length ? displaypanEventDates.slice(0, inputValue).reverse()[0] : moment().add(1, 'y').toDate();

    return toDate;
  }
  hasWeekOption(obj, displaypanEvents) {

    if (obj.type.trim() === 'ml') {
      if (+obj.week < 5) {

        displaypanEvents = _.filter(displaypanEvents, ele => (this.transform(ele['year'], +obj.week, obj.type) === true));
      } else {
        displaypanEvents = _.filter(displaypanEvents, ele => (this.transform(ele['year'], +obj.week, obj.type) === true
          || (this.transform(ele['year'], +obj.week - 1, obj.type) === true && this.transform(ele['year'], +obj.week, obj.type) === false)))
        displaypanEvents.forEach(element => {
          element.selected = true;
          if ((this.transform(element['year'], +obj.week, obj.type) === true)) {
            if (!!displaypanEvents[displaypanEvents.indexOf(element) - 1]) {
              if (displaypanEvents[displaypanEvents.indexOf(element) - 1].selected) {
                displaypanEvents[displaypanEvents.indexOf(element) - 1].selected = false;
              }
            }
          }

        });
        return displaypanEvents.filter(e => e.selected);
      }

    } else {
      if (+obj.week < 5) {
        displaypanEvents = _.filter(displaypanEvents, ele => (this.transform(ele['date'], +obj.week, obj.type) === true));
      } else {
        displaypanEvents = _.filter(displaypanEvents, ele => (
          (this.transform(ele['date'], +obj.week, obj.type) === true) ||
          (this.transform(ele['date'], +obj.week, obj.type) === false && this.transform(ele['date'], +obj.week - 1, obj.type) === true)

        ))
        displaypanEvents.forEach(element => {
          element.selected = true;
          if ((this.transform(element['date'], +obj.week, obj.type) === true)) {
            if (!!displaypanEvents[displaypanEvents.indexOf(element) - 1]) {
              if (displaypanEvents[displaypanEvents.indexOf(element) - 1].selected) {
                displaypanEvents[displaypanEvents.indexOf(element) - 1].selected = false;
              }
            }
          }

        });

      }
    }

    return displaypanEvents.filter(e => e.selected);
  }
  transform(dateStamp: any, week: number, type: string): boolean {

    if (type.trim() === 'en') {
      let date = (new Date(dateStamp).getDate());
      let weekNo = (+date / 7); // Math.floor     
      // return (+weekNo === (week-1));
      return (+weekNo > (week - 1) && (+weekNo <= (week)));
    } else {
      let str = dateStamp.split('-')[2];
      let weekNo = (+str / 7); // Math.floor
      //  return (+weekNo === (week-1)); 
      return (+weekNo > (week - 1) && (+weekNo <= (week)));
    }
  }
  nextValidDate(panEvents, from) {
    const panEvnt = _.find(panEvents, e => DateService.isAfter(((moment(e.date).toDate() as any) * 1) as any, from));

    let index =
      _.findIndex(panEvents, e => DateService.isSame(panEvnt.date, ((moment(e.date).toDate() as any) * 1) as any))
    return index > -1 ? index : this.nextValidDate(panEvents, panEvnt.date);
  }
  countFromDateToToDate(fromDate, panEvents: any[], inputValue) {
    let from: any = (moment(fromDate).set({ hour: 0, minute: 0, second: 0 }).toDate() as any) * 1;
    let index = _.findIndex(panEvents, e => DateService.isSame(from, ((moment(e.date).toDate() as any) * 1) as any));
    if (index === -1) {
      index = this.nextValidDate(panEvents, from);
    }
    return moment(panEvents.slice(index, index + inputValue).reverse()[0].date).toDate();

  }
  getMonthSubFilterOptions(month: number) {

    if ((month !== undefined || month !== null) && month >= 1) {
      const isMalayalam = sessionStorage.getItem('language') === 'malayalam';
      const allEnMonths = isMalayalam ? _.map(EN_MONTHS, e => { return { range: e.range, id: e.id, name: e.ml, prefix: (e.id + 1) + '.' } }) : _.map(EN_MONTHS, e => { return { range: e.range, id: e.id, name: e.en, prefix: (e.id + 1) + '.' } });

      const currentMonth = _.find(allEnMonths, e => e.id === (month - 1));
      const monthDates: [] = _.map(_.range(1, currentMonth.range + 1), e => { return { date: e, text: currentMonth.name + ' ' + e, monthId: month - 1 } });

      return monthDates;
    }
    return [];

  }
  get translatorPipe(): TranslatePipe {
    if (!this._translatorPipe) {
      this._translatorPipe = new TranslatePipe(this.ts);
    }
    return this._translatorPipe;
  }
}
